import { formatMoney, convertMoneyToMinorUnits } from '@theme/money-formatting';


const BEISPIEL_PLZ = {
  DE: '10115',
  AT: '1010',
  NL: '1011 AB',
  BE: '1000',
  LU: '1009',
  FR: '75001',
  IT: '00100',
  ES: '28001',
  PT: '1000-001',
  IE: 'D01 F5P2',
  DK: '1050',
  SE: '111 20',
  FI: '00100',
  PL: '00-001',
  CZ: '110 00',
  SK: '811 01',
  SI: '1000',
  HR: '10000',
  HU: '1011',
  RO: '010011',
  BG: '1000',
  GR: '105 63',
  EE: '10111',
  LV: 'LV-1050',
  LT: '01100',
  CH: '8001',
};

const ZWISCHENSPEICHER = new Map();
const LAEUFT = new Map();

function schluessel(land, summe) {
  return land + '|' + summe;
}

function wurzel() {
  try {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  } catch (e) {
    return '/';
  }
}

async function tarif(land, summe, waehrung) {
  const k = schluessel(land, summe);
  if (ZWISCHENSPEICHER.has(k)) return ZWISCHENSPEICHER.get(k);
  if (LAEUFT.has(k)) return LAEUFT.get(k);

  const versprechen = (async () => {
    try {
      const plz = BEISPIEL_PLZ[land];
      if (!plz) return null;
      const abfrage =
        'shipping_address%5Bcountry%5D=' + encodeURIComponent(land) +
        '&shipping_address%5Bzip%5D=' + encodeURIComponent(plz);
      const antwort = await fetch(wurzel() + 'cart/shipping_rates.json?' + abfrage, {
        headers: { Accept: 'application/json' },
      });
      if (!antwort.ok) return null;
      const daten = await antwort.json();
      const raten = (daten && daten.shipping_rates) || [];
      if (!raten.length) return null;

      let guenstigste = null;
      for (const rate of raten) {
        const cent = convertMoneyToMinorUnits(String(rate.price), waehrung);
        if (cent === null) continue;
        if (guenstigste === null || cent < guenstigste) guenstigste = cent;
      }
      return guenstigste;
    } catch (e) {
      return null;
    }
  })();

  LAEUFT.set(k, versprechen);
  const ergebnis = await versprechen;
  LAEUFT.delete(k);
  if (ergebnis !== null) ZWISCHENSPEICHER.set(k, ergebnis);
  return ergebnis;
}

let letzterVersand = null;
let letzteWaehrung = '';
let letztesFormat = '';

function zusatzRichten() {
  const unbekannt = letzterVersand === null;
  for (const zusatz of document.querySelectorAll('[data-gesamt-zusatz]')) {
    if (zusatz.hidden !== unbekannt) continue;
    zusatz.hidden = !unbekannt;
  }
}

function gesamtAktualisieren(versandCent, waehrung, format) {
  letzterVersand = versandCent;
  document.dispatchEvent(new CustomEvent('3idee:versandtarif',
    { detail: { cent: versandCent } }));
  letzteWaehrung = waehrung;
  letztesFormat = format;

  const feld = document.querySelector('[data-gesamt-wert]');
  if (feld) {
    const basis = parseInt(feld.getAttribute('data-gesamt-betrag') || '', 10);
    if (!Number.isNaN(basis)) {
      const text = formatMoney(basis + versandCent, format, waehrung);
      if (feld.textContent.trim() !== text) feld.textContent = text;
      feld.setAttribute('value', text);
    }
  }
  zusatzRichten();
}


function standVon(el) {
  return (el.getAttribute('data-versand-land') || '')
    + '|' + (el.getAttribute('data-versand-summe') || '');
}

const NACHGEFASST = new Set();

function schwelleCent(liste, land) {
  if (!liste || !land) return null;
  const gesucht = String(land).trim().toUpperCase();
  for (const roh of String(liste).split(',')) {
    const teile = roh.split(':');
    if (teile.length < 2) continue;
    if (teile[0].trim().toUpperCase() !== gesucht) continue;
    const euro = parseFloat(teile[1].trim().replace(',', '.'));
    if (!isFinite(euro) || euro <= 0) return null;
    return Math.round(euro * 100);
  }
  return null;
}

function sofortFrei(el) {
  const grenze = schwelleCent(el.getAttribute('data-versand-liste'),
                              el.getAttribute('data-versand-land'));
  if (grenze === null) return false;
  const summe = parseInt(el.getAttribute('data-versand-summe') || '', 10);
  if (Number.isNaN(summe)) return false;
  return summe >= grenze;
}

async function zeileFuellen(el) {
  const land = el.getAttribute('data-versand-land');
  const summe = el.getAttribute('data-versand-summe') || '';
  const waehrung = el.getAttribute('data-versand-currency') || 'EUR';
  const format = el.getAttribute('data-versand-money-format') || '';
  if (!land || !format) return;

  el.setAttribute('data-versand-gefragt', standVon(el));

  if (sofortFrei(el)) {
    const freiSofort = el.getAttribute('data-versand-frei') || '';
    if (freiSofort && el.textContent.trim() !== freiSofort) el.textContent = freiSofort;
    el.classList.remove('cart-uebersicht__wert--leise');
    el.classList.add('cart-uebersicht__wert--frei');
    gesamtAktualisieren(0, waehrung, format);
  }

  const cent = await tarif(land, summe, waehrung);
  if (cent === null) {
    const marke = standVon(el);
    if (!NACHGEFASST.has(marke)) {
      NACHGEFASST.add(marke);
      window.setTimeout(() => {
        if (el.isConnected && el.getAttribute('data-versand-gefragt') === marke) {
          el.removeAttribute('data-versand-gefragt');
        }
        alleFuellen();
      }, 1200);
    }
    return;
  }

  if (cent === 0) {
    const freiWort = el.getAttribute('data-versand-frei') || '';
    if (freiWort && el.textContent.trim() !== freiWort) el.textContent = freiWort;
    el.classList.remove('cart-uebersicht__wert--leise');
    el.classList.add('cart-uebersicht__wert--frei');
    gesamtAktualisieren(0, waehrung, format);
    return;
  }

  const text = formatMoney(cent, format, waehrung);
  if (el.textContent.trim() !== text) el.textContent = text;
  el.classList.remove('cart-uebersicht__wert--leise');
  gesamtAktualisieren(cent, waehrung, format);
}

function alleFuellen() {
  const zeilen = document.querySelectorAll('[data-versand-wert]');
  for (const el of zeilen) {
    if (el.getAttribute('data-versand-gefragt') === standVon(el)) continue;
    zeileFuellen(el);
  }
  if (letzterVersand !== null) gesamtAktualisieren(letzterVersand, letzteWaehrung, letztesFormat);
}

document.addEventListener('shopify:cart:lines-update', () => {
  letzterVersand = null;
  for (const el of document.querySelectorAll('[data-versand-gefragt]')) {
    el.removeAttribute('data-versand-gefragt');
  }
  zusatzRichten();
  window.requestAnimationFrame(alleFuellen);
});

let angemeldet = false;
function starten() {
  if (angemeldet) return;
  angemeldet = true;
  alleFuellen();
  const beobachter = new MutationObserver(() => {
    window.requestAnimationFrame(alleFuellen);
  });
  beobachter.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', starten);
} else {
  starten();
}
